export enum ProjectListColId {
  CORPORATE_USERS = 'corporateUsers',
  EXTERNAL_PROGRAM_NUMBER = 'externalProgramNumber',
  EXTERNAL_PROJECT_CUSTOMERS = 'externalProgramCustomers',
  EXTERNAL_PROJECT_NUMBER = 'externalProjectNumber',
  NAME = 'name',
  VALID_SINCE = 'validSince',
  VALID_UNTIL = 'validUntil',
}
